import offset from '@/js/helpers/offset'
import SmoothScroll from 'smooth-scroll'

export default class BackToTop {
    constructor(btn) {
        if (!btn) return

        this.btn = document.querySelector(btn)

        this.init()
    }

    init() {
        this.findElements()
        this.attachEvents()
    }

    findElements() {
        this.footer = document.querySelector('.footer')
        this.isFixed = false
        this.footerHeight = this.footer.clientHeight
        this.footerTop = offset(this.footer).top
        this.elementTop = offset(this.btn).top
        this.activeClass = 'back-to-top'
        this.topOffsetToShowBtn = 150
    }

    attachEvents() {
        this.resizeHandler()

        window.addEventListener('load', this.resizeHandler.bind(this))
        window.addEventListener('resize', this.resizeHandler.bind(this))
        window.addEventListener('scroll', this.resizeHandler.bind(this))

        this.btn.addEventListener('click', this.goToTop.bind(this))
    }

    goToTop() {
        const pageTop = document.querySelector('.wrapper')

        new SmoothScroll().animateScroll(pageTop)
    }

    resizeHandler() {
        this.btnHeight = this.btn.clientHeight
        this.footerHeight = this.footer.clientHeight
        this.footerTop = offset(this.footer).top
        this.elementTop = offset(this.btn).top

        this.scrollHandler()
    }

    scrollHandler() {
        if (window.pageYOffset > this.topOffsetToShowBtn) {
            this.btn.classList.add(`${this.activeClass}--show`)
            this.btn.classList.add(`${this.activeClass}--fixed`)
        } else {
            this.btn.classList.remove(`${this.activeClass}--show`)
        }
    }
}
